import template from "./tankers.html";
import controller from "./tankers.controller";
import "./tankers.scss";

let branchManagementTankersComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementTankersComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tankers/tankers.component.js